import { useReduxState } from 'hooks';
import api from 'api';
import { ConfirmButton } from 'components/common';

interface Props {
  stepId: number;
  updateSteps: () => Promise<void>;
}

const PathStepsRemove = ({ stepId, updateSteps }: Props) => {
  const {
    messages,
    pageState: { path }
  } = useReduxState();

  const handleRemove = async () => {
    await api.delete(`/admin/paths/${path.id}/steps/${stepId}`);
    await updateSteps();
    return true;
  };

  return (
    <ConfirmButton
      actionText={messages.commonRemove}
      buttonIcon="trash-alt"
      buttonText={messages.commonRemove}
      category="danger"
      confirmText={messages.pathsStepsRemoveStepConfirm}
      confirmTitle={messages.pathsStepsRemoveStep}
      onConfirm={handleRemove}
      successMessage={messages.pathsStepsRemoveStepSuccess}
      stopPropagation={true}
    />
  );
};

export default PathStepsRemove;
